import type from './type.js';
export default (function (args) {
  if (args.length < 2) return null;
  var l = args.length - 1;
  if (type(args[l]) == 'string') return args[l].toLowerCase();
  return null;
});